import React, { useState } from "react";
import Checkbox from "../common/Checkbox";
import instance from "../../axios";
import { logInUserInfo } from "../../Actions/Users";
import { updateLayer } from "../../Actions/Maps";
import { notifyError, notifySuccess } from "../../Utils/CustomNotifcations";
import { Box, Grid, Paper } from "@mui/material";
import Button from "../common/Button";
import { checkPrivileges, errorHandler } from "../../Helpers";

export function formSubmit(userId, payload, dispatch) {
    return instance({
        url: `api/users/${userId}`,
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        data: payload,
    })
        .then((user) => {
            dispatch(logInUserInfo(user));
            dispatch(updateLayer({ id: user.map }));
            dispatch(notifySuccess("servicePerferenceInfoIsUpdated"));
            return user;
        })
        .catch((error) => {
            errorHandler(error, dispatch);
            throw error;
        });
}

const EmailServiceEstimate = (props) => {
    const originalEstimate =
        props.logInUser?.sendNotification?.estimate || false;

    const originalOutstanding =
        props.logInUser?.sendNotification?.outstanding || false;

    const originalAipms =
        props.logInUser?.sendNotification?.aipms || false;

    const originalPushNotification =
        props.logInUser?.sendNotification?.pushNotification || false;

    const originalLicense =
        props.logInUser?.sendNotification?.license || false;

    const originalInsurance =
        props.logInUser?.sendNotification?.insurance || false;

    const originalCompliance =
        props.logInUser?.sendNotification?.compliance || false;

    const [isCheckedEstimate, setIsCheckedEstimate] =
        useState(originalEstimate);

    const [isCheckedOutstanding, setIsCheckedOutstanding] =
        useState(originalOutstanding);

    const [isCheckedAipms, setIsCheckedAipms] =
        useState(originalAipms);

    const [isCheckedPushNotification, setIsCheckedPushNotification] =
        useState(originalPushNotification);

    const [isCheckedLicense, setIsCheckedLicense] =
        useState(originalLicense);

    const [isCheckedInsurance, setIsCheckedInsurance] =
        useState(originalInsurance);

    const [isCheckedCompliance, setIsCheckedCompliance] =
        useState(originalCompliance);

    const isChanged =
        isCheckedEstimate !== originalEstimate ||
        isCheckedOutstanding !== originalOutstanding ||
        isCheckedAipms !== originalAipms ||
        isCheckedPushNotification !== originalPushNotification ||
        isCheckedLicense !== originalLicense ||
        isCheckedInsurance !== originalInsurance ||
        isCheckedCompliance !== originalCompliance;

    const handleChangeEstimate = (event) => {
        setIsCheckedEstimate(event.target.checked);
    };

    const handleChangeOutstanding = (event) => {
        setIsCheckedOutstanding(event.target.checked);
    };

    const handleChangeAipms = (event) => {
        setIsCheckedAipms(event.target.checked);
    };

    const handleChangePushNotification = (event) => {
        setIsCheckedPushNotification(event.target.checked);
    };

    const handleChangeLicense = (event) => {
        setIsCheckedLicense(event.target.checked);
    };

    const handleChangeInsurance = (event) => {
        setIsCheckedInsurance(event.target.checked);
    };

    const handleChangeCompliance = (event) => {
        setIsCheckedCompliance(event.target.checked);
    };

    const handleSubmitFormEstimate = async () => {
        try {
            const userPayload = {
                ...props.logInUser,
                sendNotification: {
                    ...props.logInUser.sendNotification,
                    estimate: isCheckedEstimate,
                    outstanding: isCheckedOutstanding,
                    aipms: isCheckedAipms,
                    pushNotification: isCheckedPushNotification,
                    license: isCheckedLicense,
                    insurance: isCheckedInsurance,
                    compliance: isCheckedCompliance,
                },
            };

            await formSubmit(props.logInUser.id, userPayload, props.dispatch);

        } catch (error) {
            console.error("Submit error:", error);
            props.dispatch(
                notifyError("Failed to update service preferences. Try again.")
            );
        }
    };


    return (
        <Paper
            elevation={1}
            sx={{
                p: 2.5,
                borderRadius: 2,
                background: "#fff",
                width: "100%",
                // maxWidth: 820,
            }}
        >
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                    <Checkbox
                        checked={isCheckedEstimate}
                        onChange={handleChangeEstimate}
                        label={props.translate("serviceEstimateEmail")}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Checkbox
                        checked={isCheckedOutstanding}
                        onChange={handleChangeOutstanding}
                        label={props.translate("outstandingBalanceEmail")}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Checkbox
                        checked={isCheckedAipms}
                        onChange={handleChangeAipms}
                        label={props.translate("aipmsEmail")}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Checkbox
                        checked={isCheckedPushNotification}
                        onChange={handleChangePushNotification}
                        label={props.translate("pushNotification")}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Checkbox
                        checked={isCheckedLicense}
                        onChange={handleChangeLicense}
                        label={props.translate("licenseExpiry")}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Checkbox
                        checked={isCheckedInsurance}
                        onChange={handleChangeInsurance}
                        label={props.translate("fleetExpiry")}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Checkbox
                        checked={isCheckedCompliance}
                        onChange={handleChangeCompliance}
                        label={props.translate("complianceExpiry")}
                    />
                </Grid>
            </Grid>

            {checkPrivileges("userUpdate") && (
                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!isChanged}
                        onClick={handleSubmitFormEstimate}
                    >
                        {props.translate("Save")}
                    </Button>
                </Box>
            )}
        </Paper>
    );
};

export default EmailServiceEstimate;
